import { InteractionRequiredAuthError } from '@azure/msal-browser';

type AuthErrorLike = {
  errorCode?: unknown;
  errorMessage?: unknown;
  message?: unknown;
  subError?: unknown;
};

const isString = (value: unknown): value is string => typeof value === 'string';

/**
 * MSAL 2.x does not classify AADSTS700084 as an InteractionRequiredAuthError.
 * It is returned as invalid_grant/bad_token even though the only recovery for a
 * SPA's expired, non-sliding refresh token is a new top-level authorization flow.
 */
export const requiresInteractiveAuthentication = (error: unknown): boolean => {
  if (error instanceof InteractionRequiredAuthError) {
    return true;
  }

  if (!error || typeof error !== 'object') {
    return false;
  }

  const { errorCode, errorMessage, message, subError } = error as AuthErrorLike;
  const description = [errorMessage, message].filter(isString).join(' ');

  return (
    errorCode === 'invalid_grant' &&
    (subError === 'bad_token' || description.includes('AADSTS700084'))
  );
};
